export default __webpack_public_path__ + "static/media/caliper-mobile-licensed.32548fcf.png";